import { api } from "./api";

// ════════════════════════════════════════════════════════════════════════════
// Location API Types
// ════════════════════════════════════════════════════════════════════════════

export interface Location {
  id: string;
  name: string;
  address: string | null;
  phone: string | null;
  timezone: string;
  isPrimary: boolean;
  isActive: boolean;
  displayOrder: number;
  createdAt: string;
  updatedAt: string;
}

// ════════════════════════════════════════════════════════════════════════════
// Location CRUD
// ════════════════════════════════════════════════════════════════════════════

export async function getLocations(activeOnly?: boolean): Promise<Location[]> {
  const params = activeOnly ? "?active=true" : "";
  const response = await api<{ locations: Location[] }>(`/api/locations${params}`);
  return response.locations;
}

export async function createLocation(data: {
  name: string;
  address?: string;
  phone?: string;
  timezone: string;
  isPrimary?: boolean;
  isActive?: boolean;
  displayOrder?: number;
}): Promise<Location> {
  const response = await api<{ location: Location }>("/api/locations", {
    method: "POST",
    body: JSON.stringify(data),
  });
  return response.location;
}

export async function updateLocation(
  id: string,
  data: {
    name?: string;
    address?: string | null;
    phone?: string | null;
    timezone?: string;
    isPrimary?: boolean;
    isActive?: boolean;
    displayOrder?: number;
  }
): Promise<Location> {
  const response = await api<{ location: Location }>(`/api/locations/${id}`, {
    method: "PATCH",
    body: JSON.stringify(data),
  });
  return response.location;
}

export async function deleteLocation(id: string): Promise<void> {
  await api<{ success: boolean }>(`/api/locations/${id}`, {
    method: "DELETE",
  });
}
